import { useCallback, useMemo } from 'react';
import { Item, MultiSelectProps } from './multi-select';
import { Option } from './Option';
import { Virtuoso } from 'react-virtuoso';
import { SkeletonLoader } from '../skeleton-loader';
import { debounce } from 'lodash';

export const VirtualOptionList = <T extends Item>({
  options,
  mode,
  itemDisplay,
  fetchNextPage,
  hasNextPage,
  virtualizationOptions,
}: Pick<
  MultiSelectProps<T>,
  | 'options'
  | 'mode'
  | 'itemDisplay'
  | 'fetchNextPage'
  | 'hasNextPage'
  | 'virtualizationOptions'
>) => {
  const loadMore = useCallback(() => {
    if (fetchNextPage) {
      return setTimeout(fetchNextPage, 50);
    }
  }, [fetchNextPage]);

  const fetcher = useMemo(() => {
    const fn = debounce(loadMore, 400);
    return fn;
  }, [loadMore]);

  return (
    <Virtuoso
      style={{
        height: '250px',
        width: '300px',
        ...virtualizationOptions?.virtuosoStyle,
      }}
      data={options}
      endReached={hasNextPage && fetchNextPage ? fetcher : undefined}
      itemContent={(_, option) => (
        <Option option={option} itemDisplay={itemDisplay} mode={mode} />
      )}
      components={hasNextPage ? { Footer } : {}}
    />
  );
};
const Footer = () => {
  return (
    <div className="pb-1">
      <SkeletonLoader status={'loading'} />
    </div>
  );
};
